import http from '@/utils/http';

import type { IBaseResponse, IGenreRes } from '@intelligence/types/common';

type queryItem = {
  need_filter: boolean;
  entity_type?: string[] | [];
};

const entityTypeMap: { [key: string]: string[] } = {
  mobile: ['mobile'],
  pc: ['pc'],
  console: ['console'],
  combine: ['pc', 'console'],
};
/**
 * 获取主、副品类Options集合
 * @param filterable 是否需要过滤（仅返回有数据的主、副品类Options集合）
 * @returns 主、副品类Options集合
 */
const fetchGenreSourcesOptions = (data: queryItem): IBaseResponse<IGenreRes> => {
  return http({
    url: '/api/v1/intelligence_pc/filterGenre',
    method: 'post',
    data,
    rawData: true,
  }) as IBaseResponse<IGenreRes>;
};

/**
 * 获取全量主、副品类Options集合
 * @returns 全量主、副品类Options集合
 */
export const fetchGenreSourcesOptionsAll = (entityType: any): IBaseResponse<IGenreRes> => {
  const query = {
    entity_type: entityTypeMap?.[entityType] || [],
    need_filter: false,
  };
  return fetchGenreSourcesOptions(query);
};

/**
 * 获取有数据的主、副品类Options集合（仅包含有数据的品类数据）
 * @returns 有数据的主、副品类Options集合
 */
export const fetchGenreSourcesOptionsPartial = (entityType: any): IBaseResponse<IGenreRes> => {
  const query = {
    entity_type: entityTypeMap?.[entityType] || [],
    need_filter: true,
  };
  return fetchGenreSourcesOptions(query);
};
